import React from 'react';
import { Card, Empty, selectCls } from '../bi/BiUi';
import { inputCls } from './AttendanceSection';

const BEHAVIOR = ['', 'Disruptive', 'Inattentive', 'Late to class', 'Excellent conduct'];
export const blankFlag = { pendingSubjects: [], incompleteNotes: false, behavior: '', remark: '' };

/** Section C: per-student pending homework by subject, incomplete notes, behaviour flag + remark. */
export default function ExceptionsSection({ students, att, flags, subjectDefs, patchFlag, togglePending }) {
  const list = students.filter((s) => (att[s._id] || {}).status !== 'absent');
  return (
    <Card title="C. Student Exceptions & Homework Tracking" subtitle="Only students who are not fully in order: pending homework, notes, behaviour">
      {!list.length ? <Empty>No students to track.</Empty> : (
        <ul className="divide-y divide-slate-800">
          {list.map((s) => {
            const f = flags[s._id] || blankFlag;
            return (
              <li key={s._id} className="space-y-2 py-2">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="min-w-[8rem] flex-1 text-sm font-medium">{s.name}</span>
                  {subjectDefs.map((d) => (
                    <button key={d.name} type="button" onClick={() => togglePending(s._id, d.name)} aria-pressed={f.pendingSubjects.includes(d.name)}
                      className={`rounded-full border px-2.5 py-0.5 text-[11px] ${f.pendingSubjects.includes(d.name) ? 'border-amber-400 bg-amber-400/20 text-amber-200' : 'border-slate-700 text-slate-500 hover:bg-slate-800'}`}>{d.displayName}</button>
                  ))}
                  <label className="flex items-center gap-1 text-xs text-slate-300">
                    <input type="checkbox" checked={f.incompleteNotes} onChange={(e) => patchFlag(s._id, { incompleteNotes: e.target.checked })} /> Notes incomplete</label>
                  <select value={f.behavior} onChange={(e) => patchFlag(s._id, { behavior: e.target.value })} className={`${selectCls} !py-1 text-xs`} aria-label="Behaviour flag">
                    {BEHAVIOR.map((b) => <option key={b} value={b}>{b || 'Behaviour...'}</option>)}
                  </select>
                </div>
                {(f.pendingSubjects.length > 0 || f.incompleteNotes || f.behavior) && (
                  <input value={f.remark} onChange={(e) => patchFlag(s._id, { remark: e.target.value })} maxLength={500} placeholder="Remark for parents / record" className={inputCls} />
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
